import React from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../components/common";
import { FieldActivityTable } from "../../components/FieldActivityTable";
import { SyncHealthCard } from "../../components/SyncHealthCard";

export default function FieldActivity() {
  const { code } = useParams();
  return (
    <div>
      <PageHeader title="Field Activity" subtitle="Per-collector visits, collections, new surveys and reassessments" />
      <div className="mb-4">
        <SyncHealthCard code={code} testIdPrefix="sup-sync-health" />
      </div>
      <FieldActivityTable code={code} testIdPrefix="sup-field-activity" />
    </div>
  );
}
